@if (showLoader()) {
  <mat-progress-bar
    class="mds-x-small"
    [mode]="'determinate'"
    [value]="loadProgress()"
  ></mat-progress-bar>
}
<div class="viewer-container flex flex-1 h-full w-full"></div>
